import {UserStatus} from "../store/features/Team/teamService.ts";

export const checkStatusExpiration = (currentUserStatus: UserStatus | null, setIsExpired: (value: boolean) => void) => {
    if (!currentUserStatus) return;
    if (currentUserStatus?.customUserStatus?.dueDate === null) {
        setIsExpired(false);
    } else if (currentUserStatus?.customUserStatus?.dueDate) {
        const now = new Date();
        const dueDate = new Date(currentUserStatus?.customUserStatus.dueDate);
        setIsExpired(now > dueDate);
    } else {
        setIsExpired(true);
    }
};

export const checkMeetingStatusExpiration = (currentUserStatus: UserStatus | null, setIsMeetingExpired: (value: boolean) => void) => {
    if (!currentUserStatus) return;
    if (currentUserStatus?.meetingUserStatus?.dateTo === null) {
        setIsMeetingExpired(false);
    } else if (currentUserStatus?.meetingUserStatus?.dateTo) {
        const now = new Date();
        const dueDate = new Date(currentUserStatus?.meetingUserStatus?.dateTo);
        setIsMeetingExpired(now > dueDate);
    } else {
        setIsMeetingExpired(true);
    }
};